import { Component, OnInit, Optional } from '@angular/core';
import { ModalService } from '../../../../common_resource_modules/services/modal.service';

@Component({
  selector: 'app-release-info',
  templateUrl: './release-info.component.html',
  styleUrls: ['./release-info.component.scss'],
  standalone: true,
})
export class ReleaseInfoComponent implements OnInit {
  constructor(@Optional() public activeModal?: ModalService) {}

  ngOnInit(): void {}

  onUpdateNewChanges() {
    document.location.reload();
    this.activeModal?.close();
  }
}
